import { Component } from '@angular/core';

@Component({
  selector: 'app-acesso-negado',
  standalone: true,
  imports: [],
  templateUrl: './acesso-negado.component.html',
  styleUrl: './acesso-negado.component.scss'
})
export class AcessoNegadoComponent {

}
